import { render, staticRenderFns } from "./BaseAccount.vue?vue&type=template&id=1177cbfc&scoped=true&"
import script from "./BaseAccount.vue?vue&type=script&lang=js&"
export * from "./BaseAccount.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccount.vue?vue&type=style&index=0&id=1177cbfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177cbfc",
  null
  
)

export default component.exports